export const formGroup = {
  supplierCode: { value: "", mandatory: true },
  supplierName: { value: "", mandatory: true },
  address: { value: "" },
  email: { value: "" },
  jenisSupplier: { value: null, mandatory: true },
  namaPic: { value: "", mandatory: true },
  phone: { value: "" },
  jabatan: { value: "" },
  cabang: { value: [] },
};

export const tableColumns = [
  {
    name: "supplierCode",
    label: "Kode Supplier",
  },
  {
    name: "supplierName",
    label: "Nama Supplier",
  },
  {
    name: "address",
    label: "Alamat",
  },
  {
    name: "phone",
    label: "Telepon",
  },
  {
    name: "namaPic",
    label: "Nama PIC",
  },
  {
    name: "value",
    label: "Jenis Supp.",
  },
  {
    name: "namaCabang",
    label: "Untuk Cabang",
  },
];
